import React, { useState, useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { getApi } from '../../services/apiService';
import urlConfig from '../../data/UrlConfig';
import { useAuth } from '../../context/AuthContext';
import { SparklesIcon, ArrowRightIcon } from '@heroicons/react/24/solid';

// --- Copia de tu componente CardStack ---
const getRandomCardImage = () => `https://gusaguiar.com/assets/oracle/deck-en/${Math.floor(Math.random() * 89) + 1}.png`;

const CardStack = ({ count = 3 }) => {
  const cards = useMemo(() => [...Array(count)].map(() => getRandomCardImage()), [count]);
  return (
    <div className="relative h-32 flex items-center justify-center w-full my-4">
      {cards.map((imgSrc, i) => {
        const offset = i - Math.floor(count / 2);
        const rotation = offset * 12;
        const translateX = offset * 25;
        const translateY = Math.abs(offset) * 5;
        return (
          <img
            key={i}
            src={imgSrc}
            alt="Card"
            className="absolute h-full w-auto object-contain rounded-md shadow-xl border border-gray-600/60 bg-gray-900"
            style={{
              zIndex: i,
              transformOrigin: '50% 90%',
              transform: `translateX(${translateX}px) translateY(${translateY}px) rotate(${rotation}deg)`,
            }}
          />
        );
      })}
    </div>
  );
};

const OracleCreditWidget = ({ lang = 'en' }) => {
  const { user } = useAuth();
  const [credits, setCredits] = useState(null);

  useEffect(() => {
    if (!user) return;
    const fetchCredits = async () => {
      try {
        const products = await getApi(urlConfig.user_get_products);
        const creditProduct = products.find(p => p.code === 'oracle-reading-credits');
        if (creditProduct) setCredits(parseInt(creditProduct.credits || 0));
      } catch (e) { console.error("Error loading credits:", e); }
    };
    fetchCredits();
  }, [user]);

  if (!user || credits === null) return null;

  const ui = {
    title: lang === 'es' ? 'Créditos Disponibles' : 'Credits Left',
    button: lang === 'es' ? 'Ir al Oráculo' : 'Go to Oracle'
  };

  return (
    <div className="bg-gray-900 min-h-screen pt-16 px-4">
      <div className="w-full max-w-md mx-auto flex flex-col gap-4">
        
        {/* Widget de Créditos */}
        <div className="bg-black/30 border border-gray-700 rounded-xl p-4 flex items-center justify-between shadow-md shadow-gray-700/30">
          <div className="flex items-center gap-4">
            <div className="bg-purple-500/20 p-2 rounded-lg">
              <SparklesIcon className="w-6 h-6 text-yellow-400" />
            </div>
            <div>
              <p className="text-xs text-gray-400 uppercase tracking-widest font-bold">{ui.title}</p>
              <p className="text-2xl font-bold text-white leading-none">{credits}</p>
            </div>
          </div>
        </div>

        {/* Mazo de Cartas (Debajo de los créditos) */}
        <CardStack count={3} />

        {/* Botón de navegación (Debajo de las cartas) */}
        <Link 
          to="/oracle/menu"
          className="w-full flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 text-white py-4 rounded-xl font-bold transition-all border border-gray-700"
        >
          {ui.button} <ArrowRightIcon className="w-4 h-4" />
        </Link>

      </div>
    </div>
  );
};

export default OracleCreditWidget;